import { Transport, TransportRequest, TransportResponse } from "./Transport"

export abstract class TransportInterceptor implements Transport {
  protected constructor(private readonly transport: Transport) {}
  send(request: TransportRequest): Promise<TransportResponse> {
    return this.intercept(this.transport, request)
  }

  protected abstract intercept(transport: Transport, request: TransportRequest): Promise<TransportResponse>
}
